<template>
  <div class="mt-30 ml-10 mr-10">
    <img
      class="back"
      @click="goHome"
      v-lazy="require('./../../../assets/img/back2.png')"
    />
    <p class="tac" v-show="commentList.length < 1">暂无评论</p>
    <Comment
      v-for="(item, index) in commentList"
      :key="index"
      :item="item"
    ></Comment>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Comment from "@/components/Comment";
import { getTestCommets } from "@/http/api";
export default {
  name: "userComment",
  data() {
    return {
      commentList: [],
    };
  },
  computed: {
    ...mapGetters(["eval_id"]),
  },
  created() {
    let params = {
      page: 1,
      page_size: 1000,
      evaluation: this.eval_id,
    };
    getTestCommets(params).then((res) => {
      console.log(res);
      this.commentList = res.data.objects;
    });
  },
  methods: {
    goHome() {
      this.$router.push("./introduction");
    },
  },
  components: {
    Comment,
  },
};
</script>

<style lang="less" scoped>
.back {
  width: 22px;
  height: 23px;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  left: 5px;
  top: 5px;
}
</style>